import React from "react";
import { Delete } from "@material-ui/icons";
import {
  CardHeader,
  Card,
  CardContent,
  IconButton,
  withStyles,
} from "@material-ui/core";
import StyledToolTip from "../../../../../common/StyledToolTip";

const styles = (theme) => ({
  shipperName: {
    color: theme.iconColor,
    fontSize: 20,
  },
  shipperAddress: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
  },
  card: {
    marginBottom: 16,
    overflow: "inherit",
    backgroundColor: theme.ModalBGColor,
  },
  title: {
    color: theme.ModalHeaderTextColor,
    fontSize: 10,
  },
  subheader: {
    color: theme.ToggleIconColor,
    fontSize: theme.textFontSize,
  },
  deleteIcon: {
    color: theme.violationsTextColor,
  },
  cardAction: {
    margin: 0,
  },
  actionIcon: {
    padding: 8,
  },
  headerRoot: {
    padding: 8,
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
  },
  proContentContainer: {
    padding: 8,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
});

const RemoveProCard = ({ classes, shipmentData, handleRemovePro }) => (
  <Card className={classes.card}>
    <CardHeader
      classes={{
        title: classes.title,
        subheader: classes.subheader,
        root: classes.headerRoot,
        action: classes.cardAction,
      }}
      action={
        <StyledToolTip title="Remove pro">
          <IconButton
            aria-label="remove"
            onClick={handleRemovePro(shipmentData.proId)}
            className={classes.actionIcon}
          >
            <Delete className={classes.deleteIcon} />
          </IconButton>
        </StyledToolTip>
      }
      subheader={`PRO# ${shipmentData.proId}`}
    />
    <CardContent classes={{ root: classes.proContentContainer }}>
      <div>
        <div className={classes.shipperName}>{shipmentData.shipperName}</div>
        <div className={classes.shipperAddress}>
          {shipmentData.shipperAddress}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default withStyles(styles)(RemoveProCard);
